/**
 * Zapis pliku eksportu widoku listy w przeglądarce (przenoszenie widoku między tenantami).
 * Plik przychodzi z serwera (`GET /system-modules/:slug/layouts/:id/export`).
 */

/** Nazwa pliku z nazwy widoku: znaki niedozwolone w nazwach plików → `-`. */
export function listViewFileName(slug: string, viewName: string): string {
  const part = Array.from(`${slug}-${viewName}`.trim(), (ch) => (ch.charCodeAt(0) < 32 ? '-' : ch))
    .join('')
    .replace(/[\\/:*?"<>|]+/g, '-')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^[-.]+|[-.]+$/g, '')
    .slice(0, 80);
  return `widok-listy-${part || 'eksport'}.json`;
}

export function downloadJson(data: unknown, fileName: string): void {
  const blob = new Blob([JSON.stringify(data, null, 2)], {
    type: 'application/json;charset=utf-8',
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
